import React from 'react';
import CounterAnim from './CounterAnim';

export default function StatCard({
  label,
  value,
  suffix = '',
  prefix = '',
  variant = 'primary',
  sub,
  decimals = 2,
  animate = true
}) {
  return (
    <div className={`stat-card ${variant}`}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">
        {animate
          ? <CounterAnim value={value} decimals={decimals} prefix={prefix} suffix={suffix} />
          : <span>{prefix}{value}{suffix}</span>}
      </div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}
